module.exports = __webpack_public_path__ + "static/media/IMG-20.d773e266.jpg";